(function($) {
  'use strict';
  var hasCookiesConsent = localStorage.getItem('cookies-consent');
  var $cookiesBanner = $('#cookies-banner');
  var buttonsBySelector = '.cookies-banner__footer__submit, .cookies-banner__footer__close';

  $cookiesBanner.find(buttonsBySelector).each(function(i, b) {
    $(b).click(function () {
      localStorage.setItem('cookies-consent', true);
      $cookiesBanner.hide();
    });
  });

  if (!hasCookiesConsent) $cookiesBanner.show();
})($, document, window);
